import * as _ from "lodash";

export function groupDataForSlide<T>(
  data: T[],
  numberPerSlide: number
): Array<T[]> {
  const returnData: any = [];
  let perGroup: any = [];
  let count = 0;

  data.forEach(d => {
    perGroup.push(d);
    count++;
    if (count === numberPerSlide) {
      count = 0;
      returnData.push(_.clone(perGroup));
      perGroup = [];
    }
  });

  if(perGroup.length>0){
    // add remaining data
    returnData.push(_.clone(perGroup));
  }

  return returnData;
}
